//@flow
import type { MediaPath, RecommendedScreenType } from 'types/common';
import type { JobPost } from 'types/careers';
import { get, filter } from 'lodash';
import { DateUtil } from 'utils/DateUtil';
import { CareerSelector } from 'modules/careers/selector';
import { StringUtil } from 'utils/StringUtil';

const mapJobPosts = (jobs: any, mediaPath: MediaPath): Array<JobPost> => {
  if (!jobs) {
    return [];
  }
  return jobs.map(job => mapJob(job, mediaPath));
};

const mapJob = (job: any, mediaPath: MediaPath): JobPost => {
  const city = get(job, 'city.city_name', '');
  const department = get(job, 'department.department_name', '');
  const country = get(job, 'country.country_name', '');
  const verticalName = get(job, 'vertical.vertical_name');
  return {
    id: job.id,
    name: job.job_title,
    jobShortDescription: job.job_short_description,
    jobLongDescription: job.job_long_description,
    roleShortDescription: job.job_role_short_description,
    jobShortMobileDescription: job.job_short_mobile_description,
    roleMobileShortDescription: job.job_role_short_mobile_description,
    roleLongDescription: job.job_role_long_description,
    postedDate: job.job_post_date,
    verticalId: job.vertical_id,
    status: job.status,
    listImageUrl: `${mediaPath.web}/${job.picture}`,
    listMobileImageUrl: `${mediaPath.mobile}/${job.mobile_picture}`,
    thumbNailUrl: `${mediaPath.thumbnail}/${job.picture}`,
    thumbNailUrlMobile: `${mediaPath.thumbnail}/${job.mobile_picture}`,
    distance: job.job_post_date
      ? `${DateUtil.getDistanceDateFromISOString(job.job_post_date)} AGO`
      : '',
    city: city ? city : '',
    urlSlug: job.url_slug,
    department: department ? department : '',
    country: country ? country : '',
    verticalName: verticalName ? verticalName : '',
    business: job.business,
    email: job.email,
    banner_video: job.header_video,
  };
};

const mapRelatedRoles = (state: AppState): Array<RecommendedScreenType> => {
  const currentRole = CareerSelector.getSpecificJobPosts(state);
  const getAllRoles = CareerSelector.getJobPosts(state);
  if (getAllRoles && getAllRoles) {
    const relatedRoles = [];
    const currentRoleId = currentRole ? currentRole.id : 0;
    const filteredRoles = filter(getAllRoles, function(n) {
      return currentRoleId !== n.id;
    });
    if (filteredRoles) {
      filteredRoles.map(jobRole => {
        const city = get(jobRole, 'city', '');
        const country = get(jobRole, 'country', '');
        const location = `${city}, ${country}`;
        const transformedRoles = {
          id: jobRole.id,
          name: jobRole.name,
          city: location,
          image: jobRole.listImageUrl,
          listMobileImageUrl: jobRole.listMobileImageUrl,
          listImageUrl: jobRole.listImageUrl,
          thumbNailUrl: jobRole.thumbNailUrl,
          thumbNailUrlMobile: jobRole.thumbNailUrlMobile,
          urlSlug: jobRole.urlSlug,
          location: jobRole.distance,
          information: StringUtil.sliceHtml(jobRole.jobLongDescription),
          shortInformation: StringUtil.sliceHtml(jobRole.jobShortDescription),
        };
        relatedRoles.push(transformedRoles);
      });
      return relatedRoles;
    }
    return [];
  }
  return [];
};

export const CareersMapper = {
  mapJobPosts,
  mapRelatedRoles,
};
